// import components
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress
} from '@mui/material';
import Grid from '@mui/material/Grid';

// import external libraries
import { useTranslation } from 'react-i18next';

// import types
import type { CareReceiverResponse } from 'generated/index';

// import utils
import { formatDate } from 'utils/date';

interface PatientInfoProps {
  careReceiver: CareReceiverResponse;
  isLoading?: boolean;
}

const PatientInfo = ({ careReceiver, isLoading }: PatientInfoProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'careReceiversHome' });

  const displayName =
    careReceiver.displayName || careReceiver.nameWithInitials || '-';

  return (
    <Box p={3}>
      <Card>
        <CardContent>
          {isLoading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid size={{ compact: 12, medium: 6 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {t('fields.clientNumber')}
                </Typography>
                <Typography variant="body1">
                  {careReceiver.number ?? '-'}
                </Typography>
              </Grid>
              <Grid size={{ compact: 12, medium: 6 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {t('fields.displayName')}
                </Typography>
                <Typography variant="body1">{displayName}</Typography>
              </Grid>
              <Grid size={{ compact: 12, medium: 6 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {t('fields.dateOfBirth')}
                </Typography>
                <Typography variant="body1">
                  {formatDate(careReceiver.dateOfBirth)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PatientInfo;
